var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-mail';
                    var viewUrl = 'sprite.svg#view-icon-mail';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-mail#icon-mail';
                            viewUrl = 'sprite.svg?icon-mail#view-icon-mail';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 22 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };